module.exports = __webpack_public_path__ + "assets/public/imgs/logos/hadoop.svg";